import { environment } from 'environments/environment';
import { IMqttServiceOptions } from 'ngx-mqtt';

export const MQTT_OPTIONS: IMqttServiceOptions = {
    url: environment.mqttUrl,
    clean: true,
    connectTimeout: 3000, //connection timeout in 3sec
    reconnectPeriod: 3000, // will reconnect in 3sec
    clientId: '',
    username: 'admin',
    password: 'kBasdmdWbQVNfjE444e',
    keepalive: 3000,
};
